import ReportFarms from './ReportFarms';

export default ReportFarms;
